import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import {
  DisplayPreferencesSection,
  EditPasswordSection,
  NotificationsSection,
  UserPreferencesSection,
  VersionSection,
} from 'src/features/settings';
import { PermissionsEnums } from 'src/shared/enums';
import { ComponentWithPermissions } from 'src/shared/hocs';
import { useTranslate } from 'src/shared/providers';
import { isESS } from 'src/store/user/user.selectors';

export const SettingsPage: FC = () => {
  const { t } = useTranslate();
  const shouldDisplayUserPreferences = useSelector(isESS);

  return (
    <div id="page-wrapper">
      <h2>{t('settings.settings')}</h2>
      {shouldDisplayUserPreferences && (
        <div className="pt-4">
          <UserPreferencesSection />
        </div>
      )}
      <ComponentWithPermissions permissions={PermissionsEnums.ESS_CHANGE_PASSWORD}>
        <div className="pt-4">
          <EditPasswordSection />
        </div>
      </ComponentWithPermissions>
      <ComponentWithPermissions permissions={PermissionsEnums.SHOW_NOTIFICATION_MENU}>
        <div className="pt-4">
          <NotificationsSection />
        </div>
      </ComponentWithPermissions>
      <div className="pt-4">
        <DisplayPreferencesSection />
      </div>
      <div className="pt-4">
        <VersionSection />
      </div>
    </div>
  );
};
